// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { handleConsoleError } from "../utils/common-methods";
import { GlobalSettingService } from ".";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: 'AIzaSyBiUYxsDmAZruWBpfGEybqxnc0Ln99gPBk',
//   authDomain: 'swallow-e3fc1.firebaseapp.com',
//   projectId: 'swallow-e3fc1',
//   storageBucket: 'swallow-e3fc1.firebasestorage.app',
//   messagingSenderId: '510289315940',
//   appId: '1:510289315940:web:2e90ce1024dfcf021c7771',
//  // measurementId: 'G-X5VDFB6HZ0',
// };

let firebaseApp = null;
let firestoreDb = null;

const getFirebaseApp = async () => {
  if (firebaseApp) return firebaseApp;

  try {
    const res = await GlobalSettingService.getFireStoreDetails();
    if (!res?.isSuccess || !res?.data?.length) {
      throw new Error("Firebase config not found");
    }

    const getValue = (key) =>
      GlobalSettingService.decrypt(
        res?.data.find(i => i.keyName.trim() === key)?.keyValue
      );

    const firebaseConfig = {
      apiKey: getValue("fireStoreDetails"),
      authDomain: getValue("fireStoreDomain"),
      projectId: getValue("fireStoreProject"),
      storageBucket: getValue("fireStoreBucket"),
      messagingSenderId: getValue("fireStoreSender"),
      appId: getValue("fireStoreApp"),
      measurementId: getValue("fireStoreMeasurment"),
    };

    firebaseApp = initializeApp(firebaseConfig);
    return firebaseApp;

  } catch (error) {
    handleConsoleError(error);
    throw error;
  }
};

export const getDb = async () => {
  if (firestoreDb) return firestoreDb;

  const app = await getFirebaseApp();
  firestoreDb = getFirestore(app);
  return firestoreDb;
};
// Initialize Firebase
//export const fireApp = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
//const db = getFirestore(fireApp);

const formatAMPM = (date) => {
  var dateObj = date.toDate();
  var hours = dateObj.getHours();
  var minutes = dateObj.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

const getMessages = async (threadId, onSuccess, dbName = "swallow_chat") => {
    const db = await getDb();
  const querySnap = query(
    collection(db, dbName, `${threadId}`, "messages"),
    orderBy("created")
    //limit(20)
  );
  return onSnapshot(querySnap, (snapshot) => {
    const messageData = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
      timeString: `${formatAMPM(doc.data().created)}`,
    }));
    onSuccess(messageData ?? []);
  });
};

const getMessageThreads = async (fromUserId, toUserId) => {
    const db = await getDb();
  var q1 = null;
  var q2 = null;
  if (fromUserId.length > 0) {
    q1 = query(
      collection(db, "swallow_chat"),
      where("createdBy", "==", fromUserId)
    );
  }

  if (toUserId.length > 0) {
    q2 = query(collection(db, "swallow_chat"), where("toUser", "==", toUserId));
  }
  const querySnapshot = await Promise.all([
    fromUserId.length > 0 ? await getDocs(q1) : Promise.resolve([]),
    toUserId.length > 0 ? await getDocs(q2) : Promise.resolve([]),
  ]);
  const result = await querySnapshot.map((qSnap) => {
    return qSnap?.docs?.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
  });
  var data = [];
  if (result[0]) {
    data.push(...result[0]);
  }
  if (result[1]) {
    data.push(...result[1]);
  }
  return data;
};

const getMessageThreadFrom = async (fromUserId, onSuccess) => {
    const db = await getDb();
  var querySnap = query(
    collection(db, "swallow_chat"),
    where("createdBy", "==", fromUserId)
  );

  return onSnapshot(querySnap, (snapshot) => {
    const threadData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    onSuccess(threadData ?? []);
  });
};

const getMessageThreadTo = async (toUserId, onSuccess) => {
    const db = await getDb();
  var querySnap = query(
    collection(db, "swallow_chat"),
    where("toUser", "==", toUserId)
  );
  return onSnapshot(querySnap, (snapshot) => {
    const threadData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    onSuccess(threadData ?? []);
  });
};

const subscribeForMessagingChanges = async (threadId, onSuccess) => {
    const db = await getDb();
  const querySnap = query(
    collection(db, "swallow_chat", `${threadId}`, "messages"),
    orderBy("created", "desc"),
    limit(1)
  );
  // var querySnap = query(collection(db, "swallow_chat"), where("createdBy", "==", "d5405a93-333e-41d4-df17-08dd3c67e02a"))
  return onSnapshot(querySnap, (snapshot) => {
    const threadData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    onSuccess(threadData ?? []);
  });
};

const createConversationThread = async (
  threadId,
  thread,
  dbName = "swallow_chat"
) => {
    const db = await getDb();
  await setDoc(doc(db, dbName, threadId), thread);
};

const addNewMessage = async (threadId, messageObj, dbName = "swallow_chat") => {
    const db = await getDb();
  const messageRef = collection(db, dbName, `${threadId}`, "messages");
  return await addDoc(messageRef, messageObj);
};

const isUndreadFound = async (threadId, onSuccess) => {
    const db = await getDb();
  const querySnap = query(
    collection(db, "swallow_chat", `${threadId}`, "messages"),
    // where("userId", "==", toUser),
    orderBy("created", "desc"),
    limit(1)
  );
  let unsubscribe = await onSnapshot(querySnap, async (snapshot) => {
    const messageData = await snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
      timeString: `${formatAMPM(doc.data().created)}`,
    }));
    onSuccess(messageData ?? []);
  });
  if (unsubscribe) {
    unsubscribe();
  }
};

const getLastMessage = async (threadId, dbName = "swallow_chat") => {
    const db = await getDb();
  const querySnap = query(
    collection(db, dbName, `${threadId}`, "messages"),
    // where("userId", "==", toUser),
    orderBy("created", "desc"),
    limit(1)
  );
  const querySnapshot = await getDocs(querySnap);
  const messageData = await querySnapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    timeString: `${formatAMPM(doc.data().created)}`,
  }));
  return messageData;
};

// Event Group Messaging Threads
const getGroupMessagesThread = async (userId, onSuccess) => {
    const db = await getDb();
  var querySnap = query(
    collection(db, "swallow_group_chat"),
    where("users", "array-contains", userId)
  );
  return onSnapshot(
    querySnap,
    (snapshot) => {
      const threadData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      onSuccess(threadData ?? []);
    },
    (error) => {
      handleConsoleError(error);
    }
  );
};

const getGroupMessages = async (threadId, onSuccess) => {
    const db = await getDb();
  const querySnap = query(
    collection(db, "swallow_group_chat", `${threadId}`, "messages"),
    orderBy("created"),
    limit(20)
  );
  return onSnapshot(querySnap, (snapshot) => {
    const messageData = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
      timeString: `${formatAMPM(doc.data().created)}`,
    }));
    onSuccess(messageData ?? []);
  });
};

export {  
  getMessages,
  getMessageThreads,
  createConversationThread,
  addNewMessage,
  formatAMPM,
  getMessageThreadFrom,
  getMessageThreadTo,
  subscribeForMessagingChanges,
  isUndreadFound,
  getLastMessage,
  getGroupMessagesThread,
  getGroupMessages,
};
